import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { Link } from "react-router-dom";

const donasiBarangData = [
  {
    id: 1,
    title: "Bantuan Makanan & Sembako",
    description: "Kirimkan bahan makanan dan sembako untuk korban terdampak..",
    image: "/images/barang1.jpeg",
  },
  {
    id: 2,
    title: "Bantuan Pakaian Layak Pakai",
    description: "Salurkan pakaian layak pakai untuk saudara kita di Sumatera.",
    image: "/images/barang3.jpeg",
  },
  {
    id: 3,
    title: "Bantuan Perlengkapan Anak",
    description: "Bantu kebutuhan anak-anak seperti perlengkapan sekolah dan bayi.",
    image: "/images/barang2.jpeg",
  },
];

const DonasiBarangSection: React.FC = () => {
  const Card = ({ item }: any) => (
    <div className="relative bg-[#2a2a2a] rounded-2xl overflow-hidden border border-white/10 h-full">
      {/* GRADIENT */}
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-orange-400 to-white" />

      {/* IMAGE */}
      <img src={item.image} alt={item.title} className="w-full h-[190px] " />

      {/* CONTENT */}
      <div className="p-5 text-white flex flex-col h-full">
        <h3 className="text-lg font-bold mb-2">{item.title}</h3>

        <p className="text-sm text-gray-300 mb-6">{item.description}</p>

        <div className="flex justify-center ">
          <Link to="https://belaskasih.com/product" target="_blank" className="px-10 border border-white text-white rounded-lg py-2 text-sm font-semibold hover:bg-primary transition">
            Donasi Barang
          </Link>
        </div>
      </div>
    </div>
  );

  return (
    <section className="bg-[#131010] py-16">
      <div className="max-w-[1440px] mx-auto px-4 md:px-8">
        {/* HEADER */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white">
            Donasi <span className="text-orange-400 font-bilbo">Barang</span>
          </h2>
          <p className="mt-2 text-xs md:text-sm max-w-xl mx-auto text-gray-300">Beli dan pilih sendiri barang yang kamu donasikan, Relawan akan mengirimkannya!.</p>
        </div>

        {/* ================= MOBILE & TABLET (SLIDER) ================= */}
        <div className="lg:hidden">
          <Swiper
            modules={[Autoplay]}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            spaceBetween={16}>
            {donasiBarangData.map((item) => (
              <SwiperSlide key={item.id}>
                <Card item={item} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* ================= DESKTOP (GRID) ================= */}
        <div className="hidden lg:grid grid-cols-3 gap-8">
          {donasiBarangData.map((item) => (
            <Card key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default DonasiBarangSection;
